class UpsellOffers extends HTMLElement {
  constructor() {
    super();
    this.currentProductHandle = this.dataset.currentProductHandle;
    this.productsData = {};
    this.selectedOffer = null;

    this.init();
  }

  init() {
    this.loadProductsData();
    this.bindEvents();
    this.setInitialSelection();
  }

  loadProductsData() {
    // The script is now inside the upsell-offers element
    // But we keep fallback searches for robustness
    let dataScript = this.querySelector('[data-product-data]');
    
    if (!dataScript) {
      // Fallback: search in parent (form element)
      const parent = this.parentElement;
      if (parent) {
        dataScript = parent.querySelector('[data-product-data]');
      }
    }
    
    if (dataScript) {
      try {
        this.productsData = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error('Error parsing products data:', error);
      }
    }
  }

  bindEvents() {
    // Bind click events to offers
    this.querySelectorAll('.upsell-offer').forEach(offer => {
      offer.addEventListener('click', (e) => {
        e.preventDefault();
        const radio = offer.closest('.upsell-option').querySelector('input[name="product_selection"]');
        if (radio) {
          radio.checked = true;
          this.handleProductSelection(radio);
        }
      });
    });

    // Bind change events to radio inputs
    this.querySelectorAll('input[name="product_selection"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.handleProductSelection(e.target);
      });
    });
  }

  setInitialSelection() {
    const checkedRadio = this.querySelector('input[name="product_selection"]:checked');
    if (checkedRadio) {
      this.handleProductSelection(checkedRadio);
    }
  }

  handleProductSelection(radioInput) {
    const productId = radioInput.value;
    const productHandle = radioInput.dataset.productHandle;
    const variantId = radioInput.dataset.variantId;

    this.selectedOffer = {
      handle: productHandle,
      productId: productId,
      variantId: variantId
    };

    this.updateVisualSelection(radioInput);
    this.toggleVariantPicker(productId);
  }

  updateVisualSelection(selectedRadio) {
    // Remove active class from all offers
    this.querySelectorAll('.upsell-offer').forEach(offer => {
      offer.classList.remove('upsell-offer--active');
    });

    // Add active class to selected offer
    const selectedOffer = selectedRadio.closest('.upsell-option').querySelector('.upsell-offer');
    if (selectedOffer) {
      selectedOffer.classList.add('upsell-offer--active');
    }
  }

  toggleVariantPicker(selectedProductId) {
    // Hide all variant pickers first
    this.querySelectorAll('.upsell-variant-picker').forEach(picker => {
      picker.classList.add('upsell-variant-picker--hidden');
      picker.classList.remove('upsell-variant-picker--visible');
    });

    // Show only the selected product's variant picker
    const selectedPicker = this.querySelector(`.upsell-variant-picker[data-product="${selectedProductId}"]`);
    if (selectedPicker) {
      selectedPicker.classList.remove('upsell-variant-picker--hidden');
      selectedPicker.classList.add('upsell-variant-picker--visible');

      // Wait for the variant picker to be fully visible and initialized
      // Use double requestAnimationFrame to ensure DOM is updated
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.clickFirstColorSwatch(selectedPicker);
        });
      });
    }
  }

  clickFirstColorSwatch(picker) {
    // Check if variant picker (variant-radios or variant-selects) is initialized
    const variantPicker = picker.querySelector('variant-radios, variant-selects');
    if (!variantPicker) {
      // If variant picker is not found, try again after a short delay
      setTimeout(() => {
        this.clickFirstColorSwatch(picker);
      }, 100);
      return;
    }

    // Find the first fieldset with color swatches
    // Try color-fieldset class first, then look for fieldset containing swatches-colors
    let colorFieldset = picker.querySelector('fieldset.color-fieldset');

    if (!colorFieldset) {
      // Fallback: find fieldset that contains swatches-colors
      const fieldsets = picker.querySelectorAll('fieldset');
      for (const fieldset of fieldsets) {
        if (fieldset.querySelector('.swatches-colors')) {
          colorFieldset = fieldset;
          break;
        }
      }
    }

    if (!colorFieldset) return;

    // Find the first available (not disabled, not hidden) radio input in the color fieldset
    const radios = colorFieldset.querySelectorAll('input[type="radio"]');
    let firstRadio = null;

    for (const radio of radios) {
      // Skip disabled or hidden radios
      if (radio.disabled || radio.classList.contains('disabled')) continue;

      // Check if the radio's parent li is hidden
      const parentLi = radio.closest('li');
      if (parentLi && (parentLi.classList.contains('hidden') || parentLi.style.display === 'none')) continue;

      firstRadio = radio;
      break;
    }

    if (!firstRadio) return;

    // Check if it's already checked
    if (firstRadio.checked) {
      // If already checked, trigger change event to ensure variant is updated
      firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // If not checked, check it and trigger change event
    firstRadio.checked = true;
    firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
  }

}

// Register the custom element
customElements.define('upsell-offers', UpsellOffers);
window.UpsellOffers = UpsellOffers;
